import {Component, OnInit, Input, EventEmitter, Output} from "@angular/core";
import {Router} from "@angular/router";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss']
})
export class SocialComponent implements OnInit {

  @Input() title: string;
  @Input() url: string;

  private _isShow: boolean = false;
  @Input()
  set isShow(val: boolean) {
    this._isShow = val;
  }
  get isShow() {
    return this._isShow;
  }

  constructor(private router: Router) {
  }

  ngOnInit() {

  }

  private urlSharer(sharer: any) {
    var p = sharer.params || {},
      keys = Object.keys(p),
      i: any,
      str = keys.length > 0 ? '?' : '';
    for (i = 0; i < keys.length; i++) {
      if (str !== '?') {
        str += '&';
      }
      if (p[keys[i]]) {
        str += keys[i] + '=' + encodeURIComponent(p[keys[i]]);
      }
    }
    sharer.shareUrl += str;

    if (!sharer.isLink) {
      let popWidth = sharer.width || 600,
        popHeight = sharer.height || 480,
        left = window.innerWidth / 2 - popWidth / 2 + window.screenX,
        top = window.innerHeight / 2 - popHeight / 2 + window.screenY,
        popParams = 'scrollbars=no, width=' + popWidth + ', height=' + popHeight + ', top=' + top + ', left=' + left;

      let newWindow;
      if (environment.app) {
        newWindow = cordova.InAppBrowser.open(sharer.shareUrl, '');
      } else {
        newWindow = window.open(sharer.shareUrl, '', popParams);
      }

      if (window.focus) {
        newWindow.focus();
      }
    } else {
      window.location.href = sharer.shareUrl;
    }
  }

  socialShare(sns: string) {
    switch (sns) {
      case 'facebook' :
        this.urlSharer({
          shareUrl: 'https://www.facebook.com/sharer/sharer.php',
          params: {u: this.url}
        });
        break;
      case 'kakaostory' :
        this.urlSharer({
          shareUrl: 'https://story.kakao.com/share',
          params: {
            url: this.url,
          }
        });
        break;
      case 'naver' :
        this.urlSharer({
          shareUrl: 'https://share.naver.com/web/shareView.nhn',
          params: {
            url: this.url,
            title: this.title
          }
        });
        break;
      case 'url' :
        var dumTA = document.createElement("input");
        document.body.appendChild(dumTA);
        dumTA.value = this.url;
        dumTA.select();
        document.execCommand("copy");
        dumTA.remove();
        alert('복사되었습니다.')
        break;
      default :
        this.urlSharer({
          shareUrl: 'https://twitter.com/intent/tweet/',
          params: {
            text: this.title,
            url: this.url
          }
        });
        break;

    }
  }

  @Output() onClose = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/member/shared/social/social.component.ts